<div class="bfa-modal-backdrop" *ngIf="enableBackdrop" [class.show]="isVisible"></div>
<div class="bfa-modal" [class.show]="isVisible" [ngStyle]="overrideStyles">
	<!-- Modal head -->
	<button *ngIf="enableClose" class="close" [track-event]="trackEventPrefix + 'close'" aria-label="Close" (click)="onCloseButtonClick()">
		<icon type="times"></icon>
	</button>

	<!-- Modal body -->
	<div class="body">
		<ng-content></ng-content>
	</div>
</div>
